export default {
  copyAddress: {
    id: 'track_parcel_copy_address',
    defaultMessage: 'Copy address',
  },
  addressCopied: {
    id: 'track_parcel_address_copied',
    defaultMessage: 'Address copied',
  },
  stepDatetime: {
    id: 'track_parcel_step_datetime',
    defaultMessage: '{date, html}, {time, html}',
  },
  stepOrderCreated: {
    id: 'track_parcel_step_order_created',
    defaultMessage: 'Order placed',
  },
  stepReadyToShip: {
    id: 'track_parcel_step_ready_to_ship',
    defaultMessage: 'Package ready to ship',
  },
  stepDispatched: {
    id: 'track_parcel_step_dispatched',
    defaultMessage: 'Package on its way',
  },
  stepInDelivery: {
    id: 'track_parcel_step_in_delivery',
    defaultMessage: 'Out for delivery',
  },
  stepAvailableForCollection: {
    id: 'track_parcel_step_available_for_collection',
    defaultMessage: 'Package ready to be picked up',
  },
  stepDelivered: {
    id: 'track_parcel_step_delivered',
    defaultMessage: 'Delivered',
  },
  stepFailedAttempt: {
    id: 'track_parcel_step_failed_attempt',
    defaultMessage: 'Delivery attempt failed',
  },
  stepException: {
    id: 'track_parcel_step_exception',
    defaultMessage: 'Exception',
  },
  checkpointOrderCreated: {
    id: 'track_parcel_checkpoint_order_created',
    defaultMessage: 'Order placed',
  },
  checkpointReadyToShip: {
    id: 'track_parcel_checkpoint_ready_to_ship',
    defaultMessage: 'Package ready to ship',
  },
  checkpointInTransit: {
    id: 'track_parcel_checkpoint_in_transit',
    defaultMessage: 'Package on its way',
  },
  checkpointAcceptanceScan: {
    id: 'track_parcel_checkpoint_acceptance_scan',
    defaultMessage: 'Seller gave package to the carrier',
  },
  checkpointArrivalScan: {
    id: 'track_parcel_checkpoint_arrival_scan',
    defaultMessage: 'Package arrived to the carrier sorting center',
  },
  checkpointArrivedAtDestination: {
    id: 'track_parcel_checkpoint_arrived_at_destination',
    defaultMessage: 'Package arrived in destination country',
  },
  checkpointCustomsClearanceCompleted: {
    id: 'track_parcel_checkpoint_customs_clearance_completed',
    defaultMessage: 'Customs approved package',
  },
  checkpointCustomsClearanceStarted: {
    id: 'track_parcel_checkpoint_customs_clearance_started',
    defaultMessage: 'Customs processing package',
  },
  checkpointDepartureScan: {
    id: 'track_parcel_checkpoint_departure_scan',
    defaultMessage: 'Package left the carrier sorting center',
  },
  checkpointProblemResolved: {
    id: 'track_parcel_checkpoint_problem_resolved',
    defaultMessage: 'Delivery issue marked resolved',
  },
  checkpointForwardedToDifferentDeliveryAddress: {
    id: 'track_parcel_checkpoint_forwarded_to_different_delivery_address',
    defaultMessage: 'Package forwarded to new delivery address',
  },
  checkpointOutForDelivery: {
    id: 'track_parcel_checkpoint_out_for_delivery',
    defaultMessage: 'Out for delivery',
  },
  checkpointCustomerContacted: {
    id: 'track_parcel_checkpoint_customer_contacted',
    defaultMessage: 'Recipient contacted',
  },
  checkpointDeliveryAppointmentScheduled: {
    id: 'track_parcel_checkpoint_delivery_appointment_scheduled',
    defaultMessage: 'Scheduled delivery appointment',
  },
  checkpointAvailableForPickup: {
    id: 'track_parcel_checkpoint_available_for_pickup',
    defaultMessage: 'Package ready to be picked up',
  },
  checkpointDelivered: {
    id: 'track_parcel_checkpoint_delivered',
    defaultMessage: 'Delivered',
  },
  checkpointPickedUpByCustomer: {
    id: 'track_parcel_checkpoint_picked_up_by_customer',
    defaultMessage: 'Package picked up by recipient',
  },
  checkpointSignedByCustomer: {
    id: 'track_parcel_checkpoint_signed_by_customer',
    defaultMessage: 'Recipient signed for package',
  },
  checkpointDeliveredCashOnDelivery: {
    id: 'track_parcel_checkpoint_delivered_cash_on_delivery',
    defaultMessage: 'Package delivered and fee paid by recipient',
  },
  checkpointFailedAttempt: {
    id: 'track_parcel_checkpoint_failed_attempt',
    defaultMessage: 'Delivery attempt failed',
  },
  checkpointAddresseeNotAvailable: {
    id: 'track_parcel_checkpoint_addressee_not_available',
    defaultMessage: 'Recipient unavailable to sign for package',
  },
  checkpointBusinessClosed: {
    id: 'track_parcel_checkpoint_business_closed',
    defaultMessage: 'Driver couldn’t access delivery location',
  },
  checkpointException: {
    id: 'track_parcel_checkpoint_exception',
    defaultMessage: 'Exception',
  },
  checkpointCustomerMoved: {
    id: 'track_parcel_checkpoint_customer_moved',
    defaultMessage: 'Customer moved',
  },
  checkpointCustomerRefusedDelivery: {
    id: 'track_parcel_checkpoint_customer_refused_delivery',
    defaultMessage: 'Customer refused delivery',
  },
  checkpointDelayedCustomsClearance: {
    id: 'track_parcel_checkpoint_delayed_customs_clearance',
    defaultMessage: 'Delayed (Customs clearance)',
  },
  checkpointDelayedExternalFactors: {
    id: 'track_parcel_checkpoint_delayed_external_factors',
    defaultMessage: 'Delayed (External factors)',
  },
  checkpointHeldForPayment: {
    id: 'track_parcel_checkpoint_held_for_payment',
    defaultMessage: 'Held for payment',
  },
  checkpointIncorrectAddress: {
    id: 'track_parcel_checkpoint_incorrect_address',
    defaultMessage: 'Incorrect address',
  },
  checkpointPickUpMissed: {
    id: 'track_parcel_checkpoint_pick_up_missed',
    defaultMessage: 'Pick up missed',
  },
  checkpointRejectedByCarrier: {
    id: 'track_parcel_checkpoint_rejected_by_carrier',
    defaultMessage: 'Rejected by carrier',
  },
  checkpointReturningToSender: {
    id: 'track_parcel_checkpoint_returning_to_sender',
    defaultMessage: 'Returning to sender',
  },
  checkpointReturnedToSender: {
    id: 'track_parcel_checkpoint_returned_to_sender',
    defaultMessage: 'Returned to sender',
  },
  checkpointShipmentDamage: {
    id: 'track_parcel_checkpoint_shipment_damage',
    defaultMessage: 'Shipment damage',
  },
  checkpointShipmentLost: {
    id: 'track_parcel_checkpoint_shipment_lost',
    defaultMessage: 'Shipment lost',
  },
  checkpointCarrierPickupFailed: {
    id: 'track_parcel_checkpoint_carrier_pickup_failed',
    defaultMessage: 'Carrier pickup failed',
  },
}
